const moment = require('moment');

export function sortWorkLogsByDate(workLogs) {
  workLogs.sort((a, b) => moment(a.date).diff(moment(b.date)));
}

export function sortWorkLogsByStartTimestamp(workLogs) {
  workLogs.sort((a, b) => {
    const t1 = a.startTimestamp;
    const t2 = b.startTimestamp;
    if (t1 && t2) {
      return moment(t1).isAfter(moment(t2)) ? -1 : 1;
    }
    return 0;
  });
}



// WEBPACK FOOTER //
// ./src/helpers/sort.js